import api from './api';

// Garanti arayüzü
export interface Warranty {
  SonIslem: number;
  Tip: string;
  MotorMu: boolean;
  Kategori: number;
  KategoriAdi: string;
  MarkaAdi: string;
  Model: number;
  ModelAdi: string;
  RenkAdi: string;
  Sasi: string;
  Motor: string;
  MontajBedeli: number;
  BakimYapilabilir: boolean;
  TalepGirilebilir: boolean;
  CariAdi: string;
  Ulke: number;
  MontajYapildiMi: boolean;
  TalepVarMi: boolean;
  SaticiTelefon: string;
  SaticiAdres: string;
  SaticiIl: number;
  SaticiIlAdi: string;
  SaticiIlce: number;
  SaticiIlceAdi: string;
  SaticiEPosta: string;
  SaticiFaturaNo: string;
  SaticiBelgeNo: string;
  SaticiTeslimYeri: string;
  SaticiTeslimEdilen: string;
  AliciTelefon: string;
  AliciAdres: string;
  AliciIl: number;
  AliciIlAdi: string;
  AliciIlce: number;
  AliciIlceAdi: string;
  AliciEPosta: string;
  AliciFaturaNo: string;
  AliciBelgeNo: string;
  AliciTeslimYeri: string;
  AliciTeslimEdilen: string;
  IslemAdi: string;
  GarantiDurumu: number;
  GarantiDurumuAciklamasi: string;
  AktifMi: boolean;
  GarantiDevamEdiyorMu: boolean;
  SaticiFaturaTarihi: string;
  SaticiTeslimTarihi: string;
  AliciFaturaTarihi: string | null;
  AliciTeslimTarihi: string;
  GarantiBitisTarihi: string;
  IslemTarihi: string;
  Id: number;
}

// API yanıt arayüzü
export interface WarrantiesResponse {
  total: number;
  data: Warranty[];
}

// Garantileri getir
export const getWarranties = async (
  page: number = 1,
  limit: number = 50,
  statusFilter?: string[],
  dateFilter?: { startDate?: string; endDate?: string },
  showAllCoupon?: boolean,
  userId?: number
): Promise<WarrantiesResponse> => {
  try {
    // Benzersiz bir storeId oluştur
    const uniqueId = Date.now();
    const storeId = `store-${uniqueId}`;
    
    // Form data oluştur
    const formData = new URLSearchParams();
    
    // Temel parametreler
    const ignoreclientValue = showAllCoupon !== undefined ? showAllCoupon.toString() : 'false';

    formData.append('ignoreclient', ignoreclientValue);
    formData.append('isTree', 'false');
    formData.append('limitless', 'false');
    formData.append('storeId', storeId);
    formData.append('model', 'Kuponlar');
    
    // Alanlar
    const fields = [
      'SonIslem', 'Tip', 'MotorMu', 'Kategori', 'KategoriAdi', 'MarkaAdi', 'Model', 'ModelAdi',
      'RenkAdi', 'Sasi', 'Motor', 'MontajBedeli', 'BakimYapilabilir', 'TalepGirilebilir', 'CariAdi',
      'Ulke', 'MontajYapildiMi', 'TalepVarMi', 'SaticiTelefon', 'SaticiAdres', 'SaticiIl', 'SaticiIlAdi',
      'SaticiIlce', 'SaticiIlceAdi', 'SaticiEPosta', 'SaticiFaturaNo', 'SaticiBelgeNo', 'SaticiTeslimYeri',
      'SaticiTeslimEdilen', 'AliciTelefon', 'AliciAdres', 'AliciIl', 'AliciIlAdi', 'AliciIlce', 'AliciIlceAdi',
      'AliciEPosta', 'AliciFaturaNo', 'AliciBelgeNo', 'AliciTeslimYeri', 'AliciTeslimEdilen', 'IslemAdi',
      'GarantiDurumu', 'GarantiDurumuAciklamasi', 'AktifMi', 'GarantiDevamEdiyorMu', 'SaticiFaturaTarihi',
      'SaticiTeslimTarihi', 'AliciFaturaTarihi', 'AliciTeslimTarihi', 'GarantiBitisTarihi', 'IslemTarihi', 'Id'
    ];
    formData.append('fields', fields.join(','));
    
    formData.append('writemodel', '');
    formData.append('fromview', 'true');
    formData.append('masterfield', 'Cari');
    formData.append('masterid', userId ? userId.toString() : '0');
    
    // Sayfalama
    const start = (page - 1) * limit;
    formData.append('page', page.toString());
    formData.append('start', start.toString());
    formData.append('limit', limit.toString());
    
    // Sıralama
    formData.append('sort', 'Sasi');
    formData.append('dir', 'ASC');

    // Filtreler
    const filters: any[] = [];
    
    // Varsayılan filtre - her zaman ekle
    filters.push({
      "type": "list",
      "value": ["Onay Bekliyor", "Onaylandı", "İptal Edildi"],
      "field": "IslemAdi"
    });
    
    // Durum filtresi (eğer belirtilmişse varsayılan filtreyi geçersiz kıl)
    if (statusFilter && statusFilter.length > 0) {
      // Varsayılan filtreyi kaldır ve özel filtreyi ekle
      filters.pop();
      filters.push({
        type: 'list',
        value: statusFilter,
        field: 'IslemAdi'
      });
    }
    
    // Tarih filtresi
    if (dateFilter) {
      if (dateFilter.startDate) {
        filters.push({
          type: 'date',
          comparison: 'gt',
          value: dateFilter.startDate,
          field: 'IslemTarihi'
        });
      }
      
      if (dateFilter.endDate) {
        filters.push({
          type: 'date',
          comparison: 'lt',
          value: dateFilter.endDate,
          field: 'IslemTarihi'
        });
      }
    }

    if (filters.length > 0) {
      formData.append('filter', JSON.stringify(filters));
    }

    const response = await api.post<WarrantiesResponse>('/data/read', formData);

    return response.data;
  } catch (error) {
    console.error('Garantiler yüklenirken hata:', error);
    throw error;
  }
};

// Garanti ara
export const searchWarranties = async (
  query: string,
  searchType: 'serial' | 'invoice',
  page: number = 1,
  limit: number = 50,
  showAllCoupon?: boolean,
  userId?: number
): Promise<WarrantiesResponse> => {
  try {
    // Benzersiz bir storeId oluştur
    const uniqueId = Date.now();
    const storeId = `store-${uniqueId}`;
    
    // Form data oluştur
    const formData = new URLSearchParams();
    
    // Temel parametreler
    const ignoreclientValue = showAllCoupon !== undefined ? showAllCoupon.toString() : 'false';

    formData.append('ignoreclient', ignoreclientValue);
    formData.append('isTree', 'false');
    formData.append('limitless', 'false');
    formData.append('storeId', storeId);
    formData.append('model', 'Kuponlar');
    
    // Alanlar
    const fields = [
      'SonIslem', 'Tip', 'MotorMu', 'Kategori', 'KategoriAdi', 'MarkaAdi', 'Model', 'ModelAdi',
      'RenkAdi', 'Sasi', 'Motor', 'MontajBedeli', 'BakimYapilabilir', 'TalepGirilebilir', 'CariAdi',
      'Ulke', 'MontajYapildiMi', 'TalepVarMi', 'SaticiTelefon', 'SaticiAdres', 'SaticiIl', 'SaticiIlAdi',
      'SaticiIlce', 'SaticiIlceAdi', 'SaticiEPosta', 'SaticiFaturaNo', 'SaticiBelgeNo', 'SaticiTeslimYeri',
      'SaticiTeslimEdilen', 'AliciTelefon', 'AliciAdres', 'AliciIl', 'AliciIlAdi', 'AliciIlce', 'AliciIlceAdi',
      'AliciEPosta', 'AliciFaturaNo', 'AliciBelgeNo', 'AliciTeslimYeri', 'AliciTeslimEdilen', 'IslemAdi',
      'GarantiDurumu', 'GarantiDurumuAciklamasi', 'AktifMi', 'GarantiDevamEdiyorMu', 'SaticiFaturaTarihi',
      'SaticiTeslimTarihi', 'AliciFaturaTarihi', 'AliciTeslimTarihi', 'GarantiBitisTarihi', 'IslemTarihi', 'Id'
    ];
    formData.append('fields', fields.join(','));
    
    formData.append('writemodel', '');
    formData.append('fromview', 'true');
    formData.append('masterfield', 'Cari');
    formData.append('masterid', userId ? userId.toString() : '0');
    
    // Sayfalama
    const start = (page - 1) * limit;
    formData.append('page', page.toString());
    formData.append('start', start.toString());
    formData.append('limit', limit.toString());
    
    // Sıralama
    formData.append('sort', 'Sasi');
    formData.append('dir', 'ASC');

    // Arama filtresi ekle
    const searchFilters = [];
    
    if (searchType === 'serial') {
      searchFilters.push({
        "type": "string",
        "value": query,
        "field": "Sasi"
      });
    } else if (searchType === 'invoice') {
      searchFilters.push({
        "type": "string",
        "value": query,
        "field": "SaticiFaturaNo"
      });
    }

    if (searchFilters.length > 0) {
      formData.append('filter', JSON.stringify(searchFilters));
    }

    const response = await api.post<WarrantiesResponse>('/data/read', formData);

    return response.data;
  } catch (error) {
    console.error('Garanti arama hatası:', error);
    throw error;
  }
};

// Garanti detayı getir
export const getWarrantyDetail = async (id: number, showAllCoupon?: boolean, userId?: number): Promise<Warranty> => {
  try {
    // Benzersiz bir storeId oluştur
    const uniqueId = Date.now();
    const storeId = `store-${uniqueId}`;
    
    // Form data oluştur
    const formData = new URLSearchParams();
    
    // Temel parametreler
    const ignoreclientValue = showAllCoupon !== undefined ? showAllCoupon.toString() : 'false';

    formData.append('ignoreclient', ignoreclientValue);
    formData.append('isTree', 'false');
    formData.append('limitless', 'false');
    formData.append('storeId', storeId);
    formData.append('model', 'Kuponlar');
    
    // Alanlar
    const fields = [
      'SonIslem', 'Tip', 'MotorMu', 'Kategori', 'KategoriAdi', 'MarkaAdi', 'Model', 'ModelAdi',
      'RenkAdi', 'Sasi', 'Motor', 'MontajBedeli', 'BakimYapilabilir', 'TalepGirilebilir', 'CariAdi',
      'Ulke', 'MontajYapildiMi', 'TalepVarMi', 'SaticiTelefon', 'SaticiAdres', 'SaticiIl', 'SaticiIlAdi',
      'SaticiIlce', 'SaticiIlceAdi', 'SaticiEPosta', 'SaticiFaturaNo', 'SaticiBelgeNo', 'SaticiTeslimYeri',
      'SaticiTeslimEdilen', 'AliciTelefon', 'AliciAdres', 'AliciIl', 'AliciIlAdi', 'AliciIlce', 'AliciIlceAdi',
      'AliciEPosta', 'AliciFaturaNo', 'AliciBelgeNo', 'AliciTeslimYeri', 'AliciTeslimEdilen', 'IslemAdi',
      'GarantiDurumu', 'GarantiDurumuAciklamasi', 'AktifMi', 'GarantiDevamEdiyorMu', 'SaticiFaturaTarihi',
      'SaticiTeslimTarihi', 'AliciFaturaTarihi', 'AliciTeslimTarihi', 'GarantiBitisTarihi', 'IslemTarihi', 'Id'
    ];
    formData.append('fields', fields.join(','));
    
    formData.append('writemodel', '');
    formData.append('fromview', 'true');
    formData.append('masterfield', 'Cari');
    formData.append('masterid', userId ? userId.toString() : '0');
    
    // Sayfalama (tek kayıt)
    formData.append('page', '1');
    formData.append('start', '0');
    formData.append('limit', '1');
    
    // Sıralama
    formData.append('sort', 'Id');
    formData.append('dir', 'ASC');

    // ID filtresi ekle
    formData.append('filter', JSON.stringify([{
      "type": "number",
      "value": id,
      "field": "Id"
    }]));

    const response = await api.post<WarrantiesResponse>('/data/read', formData);

    if (response.data.data.length === 0) {
      throw new Error('Garanti bulunamadı');
    }

    return response.data.data[0];
  } catch (error) {
    console.error('Garanti detayı yüklenirken hata:', error);
    throw error;
  }
};
